export const ORDERS_ENDPOINTS = {
  // ============================================
  // BASE ORDER OPERATIONS
  // ============================================
  STATUS: { path: "/orders/status", method: "GET" },
  CREATE_ORDER: { path: "/orders", method: "POST" },
  GET_ORDER: { path: "/orders/:id", method: "GET" },
  UPDATE_ORDER: { path: "/orders/:id", method: "PUT" },
  DELETE_ORDER: { path: "/orders/:id", method: "DELETE" },
  GET_ORDERS: { path: "/orders", method: "GET" },
  
  // ============================================
  // ORDER STATUS MANAGEMENT
  // ============================================
  UPDATE_ORDER_STATUS: { path: "/orders/:id/status", method: "PATCH" },
  BULK_UPDATE_STATUS: { path: "/orders/bulk/status", method: "PATCH" },
  GET_ORDER_TIMELINE: { path: "/orders/:id/timeline", method: "GET" },
  
  // ============================================
  // CUSTOMER OPERATIONS
  // ============================================
  GET_MY_ORDERS: { path: "/orders/my", method: "GET" },
  GET_MY_ACTIVE_ORDERS: { path: "/orders/my/active", method: "GET" },
  CANCEL_ORDER: { path: "/orders/:id/cancel", method: "POST" },
  REORDER: { path: "/orders/:id/reorder", method: "POST" },
  TRACK_ORDER: { path: "/orders/:id/track", method: "GET" },
  RATE_ORDER: { path: "/orders/:id/rate", method: "POST" },
  ADD_ORDER_NOTE: { path: "/orders/:id/notes", method: "POST" },
  
  // ============================================
  // DELIVERY MAN OPERATIONS
  // ============================================
  DELIVERYMAN_GET_READY_ORDERS: { path: "/delivery/orders/ready", method: "GET" },
  DELIVERYMAN_GET_MY_ORDERS: { path: "/delivery/orders/my", method: "GET" },
  DELIVERYMAN_ACCEPT_ORDER: { path: "/delivery/orders/:id/accept", method: "POST" },
  DELIVERYMAN_REJECT_ORDER: { path: "/delivery/orders/:id/reject", method: "POST" },
  DELIVERYMAN_UPDATE_STATUS: { path: "/delivery/orders/:id/status", method: "PUT" },
  DELIVERYMAN_START_DELIVERY: { path: "/delivery/orders/:id/start", method: "POST" },
  DELIVERYMAN_COMPLETE_DELIVERY: { path: "/delivery/orders/:id/complete", method: "POST" },
  DELIVERYMAN_UPDATE_LOCATION: { path: "/delivery/location", method: "POST" },
  DELIVERYMAN_GET_STATS: { path: "/delivery/stats", method: "GET" },
  DELIVERYMAN_GET_HISTORY: { path: "/delivery/history", method: "GET" },
  
  // ============================================
  // ADMIN OPERATIONS
  // ============================================
  ADMIN_GET_ALL_ORDERS: { path: "/admin/orders", method: "GET" },
  ADMIN_GET_ORDERS_BY_STATUS: { path: "/admin/orders/status/:status", method: "GET" },
  ADMIN_GET_ORDERS_BY_DATE: { path: "/admin/orders/date/:date", method: "GET" },
  ADMIN_GET_ORDERS_BY_RANGE: { path: "/admin/orders/range", method: "POST" },
  ADMIN_ASSIGN_DELIVERY: { path: "/admin/orders/:id/assign", method: "POST" },
  ADMIN_REASSIGN_DELIVERY: { path: "/admin/orders/:id/reassign", method: "PUT" },
  ADMIN_UPDATE_ORDER: { path: "/admin/orders/:id", method: "PUT" },
  ADMIN_DELETE_ORDER: { path: "/admin/orders/:id", method: "DELETE" },
  ADMIN_GET_ORDER_DETAILS: { path: "/admin/orders/:id/details", method: "GET" },
  ADMIN_GET_ORDER_ANALYTICS: { path: "/admin/orders/analytics", method: "GET" },
  ADMIN_EXPORT_ORDERS: { path: "/admin/orders/export", method: "POST" },
  ADMIN_BULK_ACTION: { path: "/admin/orders/bulk", method: "POST" },
  
  // ============================================
  // DELIVERY ZONE & ROUTING
  // ============================================
  GET_DELIVERY_ZONES: { path: "/delivery/zones", method: "GET" },
  CALCULATE_DELIVERY_FEE: { path: "/delivery/fee/calculate", method: "POST" },
  GET_ESTIMATED_TIME: { path: "/delivery/eta", method: "GET" },
  VALIDATE_DELIVERY_ADDRESS: { path: "/delivery/address/validate", method: "POST" },
  
  // ============================================
  // PAYMENT & INVOICE
  // ============================================
  GET_ORDER_INVOICE: { path: "/orders/:id/invoice", method: "GET" },
  PROCESS_PAYMENT: { path: "/orders/:id/payment", method: "POST" },
  REFUND_ORDER: { path: "/orders/:id/refund", method: "POST" },
  GET_PAYMENT_STATUS: { path: "/orders/:id/payment/status", method: "GET" },
  
  // ============================================
  // NOTIFICATIONS
  // ============================================
  SEND_ORDER_NOTIFICATION: { path: "/orders/:id/notify", method: "POST" },
  GET_ORDER_ALERTS: { path: "/orders/alerts", method: "GET" },
  
  // ============================================
  // REPORTS & ANALYTICS
  // ============================================
  GET_ORDERS_REPORT: { path: "/reports/orders", method: "GET" },
  GET_DELIVERY_REPORT: { path: "/reports/delivery", method: "GET" },
  GET_SALES_REPORT: { path: "/reports/sales", method: "GET" },
  GET_PERFORMANCE_METRICS: { path: "/reports/performance", method: "GET" },
  
  // ============================================
  // REAL-TIME TRACKING (WebSocket/SSE)
  // ============================================
  SUBSCRIBE_ORDER_UPDATES: { path: "/orders/:id/subscribe", method: "GET" },
  GET_LIVE_LOCATION: { path: "/delivery/live/:orderId", method: "GET" },
};
